import React from 'react';

export const FeatureFlagsContext = React.createContext({
  flags: {} as { [key: string]: boolean },
});

/**
 * Auth wrapper is a component which takes care of calling createUser endpoint
 * on the backend before any route gets a chance to render.
 * @param props
 */
export const FeatureFlagsWrapper = (props: any) => {
  return (
    <FeatureFlagsContext.Provider value={{ flags: props.flags ?? {} }}>
      {props.children}
    </FeatureFlagsContext.Provider>
  );
};
